;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { requiredString } from '@qogita/validation/string'
import { NEXT_PUBLIC_VERCEL_ENV } from 'src/core/constants.browser'

import { NEXT_PUBLIC_OBSERVABILITY_ENABLED } from './config'

const observabilityEnvironmentMap = {
  development: 'dev',
  preview: 'test',
  production: 'prod',
} as const

export const NEXT_PUBLIC_OBSERVABILITY_ENV =
  observabilityEnvironmentMap[NEXT_PUBLIC_VERCEL_ENV]

export const WEB_SELLERS_APP_NAME = 'web-sellers'

export const NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA =
  NEXT_PUBLIC_OBSERVABILITY_ENABLED
    ? requiredString(
        'NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA missing from environment',
      ).parse(process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA)
    : ''

export const NEXT_PUBLIC_GRAFANA_FARO_URL = NEXT_PUBLIC_OBSERVABILITY_ENABLED
  ? requiredString('NEXT_PUBLIC_GRAFANA_FARO_URL missing from environment')
      .url()
      .parse(process.env.NEXT_PUBLIC_GRAFANA_FARO_URL)
  : ''
